<template>
  <div class="kb-folder-card" >
    <div class="kb-icon">
      <img :src="imgBase64 ? imgBase64 :  require('../../assets/images/knowledgeBase/kb-icon.png')" style/>
    </div>
    <div v-if="showDeleteWarning" class="deleteChatWarning">
      <WarningCard @confirm="verifyDeleteChat" warningMessage="确定删除该知识库？" />
    </div>
    <div v-if="showRenameInputCard" class="inputCard">
      <InputCard inputMessage="请输入知识库名称" @confirm="verifyRenameChat"/>
    </div>
    <div class="delete-icon">
      <img @click="showDeleteWarning=true" src="../../assets/images/deleteIcon.png" style="width: 20px; height: 20px;"/>
    </div>
    <div class="rename-icon">
      <img @click="showRenameInputCard=true" src="../../assets/images/modifyIcon.png" style="width: 20px; height: 20px;"/>
    </div>
       
    <div @click="openFolder(folderName)" class="folder-name">{{ folderName }}</div>
    <div class="description">{{ description }}</div>
    <div class="file-count">
      <div class="doc-icon">
        <img src='../../assets/images/knowledgeBase/doc-icon.png' />
      </div>
      {{ fileCount-1 }} 文档
    </div>
    <div class="created-time">
      <div class="time-icon">
      <img src="../../assets/images/knowledgeBase/time-icon.png"/>
      </div>
      {{ formatTime(createdTime) }}
    </div>
  </div>
</template>

<script>
import WarningCard from '../pannels/WarningCard.vue';
import InputCard from '../pannels/InputCard.vue';
import {deletekbFolder,getkbFolderList,updatekbFolderName} from '../../api/auth';

export default {
  name: 'KbFolderCard',
  components: {
    WarningCard,
    InputCard
  },
  data() {
    return {
      showDeleteWarning: false,
      showRenameInputCard: false,
      
    }; 
  },
  props: {
    folderName: {
      type: String,
      required: true,
      default: 'Untitled'
    },
    fileCount: {
      type: Number,
      required: true,
      default: 0
    },
    createdTime: {
      type: Number,
      required: true,
      default: 0
    },
    imgBase64: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    currentUserId: {
      type: String,
      required: true
    }
  },
  methods: {
    formatTime(originalTime) {
      //const date = new Date(originalTime);
      const date = new Date(originalTime*1000);
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份从0开始，所以需要加1
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      return `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
    },
    verifyDeleteChat(ifDelete) {
      if(ifDelete){
        deletekbFolder(this.currentUserId,this.folderName).then(()=>{
          getkbFolderList(this.currentUserId).then((res)=>{
            console.log('获取知识库文件夹',res);
            this.$emit('updateFolder',res);
          })
        });
      }
      this.showDeleteWarning = false;
    },
    verifyRenameChat(ifRename,newTitle) {
      this.showRenameInputCard = false;
      if(ifRename){
        updatekbFolderName(this.currentUserId,this.folderName,newTitle).then(()=>{
          getkbFolderList(this.currentUserId).then((res)=>{
            console.log('获取知识库文件夹',res);
            this.$emit('updateFolder',res);
          }) 
        }) 
      }
    },
        //打开文件夹
   openFolder(folderName) {
      this.$router.push({ path: '/knowledgeBase/' + folderName, query: { currentUserId:this.currentUserId } });
      console.log('打开文件夹:',folderName);
    },
  }   
}
</script>

<style scoped>
.kb-icon img{
  width:60px;
  height: 60px;
  margin: 0 auto;
  border-radius: 30px;
}
.kb-folder-card {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 360px;
  height: 270px;
}
.delete-icon{
  position:absolute;
  right: 25px;
  top:20px;
  cursor: pointer;

}
.rename-icon{
  position:absolute;
  right: 50px;
  top:20px;
  cursor: pointer;
}

.folder-name {
  display:flex;
  font-weight: bold;
  font-size: 28px;
  cursor: pointer;
}
.folder-name:hover{
  color: #187EFF; 
}

.file-count {
  display:flex;
  margin-top: 5px;
  color: #888;
  .doc-icon{
    margin-right: 5px;
  }
}

.created-time {

  display:flex;
  margin-top: 5px;
  color: #888;
  .time-icon{
    margin-right: 5px;
  }
}

.rename-button,
.delete-button {
  margin-top: 10px;
}
</style>
